/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { regeneratePdfs } from '../fn/admin-pdfs/regenerate-pdfs';
import { RegeneratePdfs$Params } from '../fn/admin-pdfs/regenerate-pdfs';

@Injectable({ providedIn: 'root' })
export class AdminPdfsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `adminPdfControllerRegeneratePdfs()` */
  static readonly AdminPdfControllerRegeneratePdfsPath = '/admin/pdfs/regenerate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `regeneratePdfs()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  regeneratePdfs$Response(params: RegeneratePdfs$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return regeneratePdfs(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `regeneratePdfs$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  regeneratePdfs(params: RegeneratePdfs$Params, context?: HttpContext): Observable<void> {
    return this.regeneratePdfs$Response(params, context).pipe(map((r: StrictHttpResponse<void>): void => r.body));
  }
}
